import { Autocomplete, TextField, CircularProgress } from '@mui/material';
import { useMorningCustomerSelection } from './hooks';
import { useMorningEnabled } from '../../../../hooks/requests/integrations';

export const MorningCustomersDropdown: React.FC = () => {
  const isMorningEnabled = useMorningEnabled();
  const { selectedCustomer, morningCustomers, isFetching, handleInputChange, handleCustomerChange } =
    useMorningCustomerSelection();

  if (!isMorningEnabled) {
    return null;
  }

  return (
    <Autocomplete
      options={morningCustomers ?? []}
      getOptionLabel={(option) => `${option.name}`}
      value={selectedCustomer}
      onChange={handleCustomerChange}
      onInputChange={handleInputChange}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Morning ERP ID"
          slotProps={{
            ...params.slotProps,

            input: {
              ...params.slotProps.input,
              endAdornment: (
                <>
                  {isFetching && <CircularProgress color="inherit" size={20} />}
                  {params.slotProps.input.endAdornment}
                </>
              ),
            },

            inputLabel: {
              shrink: true,
            }
          }} />
      )}
    />
  );
};
